import React from 'react';
import { FormattedMessage } from 'react-intl';
import toTitleCase from '../utils/to-title-case';

export const TitleFormattedMessage = (props: any) => {
  return <FormattedMessage {...props} children={val => toTitleCase(val)} />;
};
